module.exports = __webpack_public_path__ + "m-share-logo-3e28eff7.png";